import React, { useEffect, useMemo, useState } from 'react'
import { CustomAutocomplete } from 'src/admin/core/components/Select/CustomAutoComplete'
import { useProfileEnterprises } from 'src/admin/scenes/entities/enterprises/hooks/useProfileEnterprises'
import { useAppTranslation } from 'src/admin/core/hooks'
import { AuthService } from 'src/admin/core/auth/authService'

export interface ProfileAgency {
  id: string
  name: string
  active: boolean
  type: string
}

export type ProfileAgenciesSelectProps = {
  onChangeValue?: (value: ProfileAgency, action: string) => void
}

export const ProfileAgenciesSelect: React.FC<ProfileAgenciesSelectProps> = ({ onChangeValue }) => {
  const { getProfileEnterprises, loading, data } = useProfileEnterprises()
  const { label } = useAppTranslation()
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const authService = new AuthService()
        const user = await authService.getUser()
        if (user?.profile?.sub) {
          getProfileEnterprises(user.profile.sub)
        }
        setIsInitialized(true)
      } catch (error) {
        console.error('Error fetching user profile:', error)
        setIsInitialized(true)
      }
    }

    fetchUserProfile()
  }, [getProfileEnterprises])

  // Extract and deduplicate agencies from profile enterprises
  const agencies = useMemo(() => {
    if (!data?.profile?.enterprises) return []

    const allAgencies: ProfileAgency[] = []
    const seenIds = new Set<string>()

    for (const enterprise of data.profile.enterprises) {
      if (enterprise.agencies) {
        for (const agency of enterprise.agencies) {
          if (!seenIds.has(agency.id)) {
            seenIds.add(agency.id)
            allAgencies.push({
              id: agency.id,
              name: agency.name,
              active: agency.active,
              type: agency.type,
            })
          }
        }
      }
    }

    return allAgencies
  }, [data])

  return (
    <CustomAutocomplete
      onChangeValue={onChangeValue}
      data={agencies}
      placeholder={label('AGENCIAS')}
      keyLabel={'name'}
      isLoading={loading || !isInitialized}
      label={label('AGENCIAS')}
    />
  )
}

